﻿export class Question {
    id: string;
    title: string;
    description: string;
    index: string;

    constructor(json: any) {
        this.id = json.id;
        this.title = json.title;
        this.description = json.description;
        this.index = json.index;
    }
}
